import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map } from 'immutable';

import { ProjectItemEntity } from './project-item.entity';

export interface IProjectListExtra
	extends IListColumnConfig<ProjectItemEntity> {
	isFixed?: boolean;
	isSelectable?: boolean;
	isSearchable?: boolean;
	isInGroup?: boolean;
	isVisible?: boolean;
	canBeHidden?: boolean;
	canBeReordered?: boolean;
	canBeChosen?: boolean;
	format?: string;
}

interface IProjectListEntity extends IListAttrs<ProjectItemEntity> {
	availableColumns: Map<string, IProjectListExtra>;
}

const entityDefaults: IProjectListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class ProjectListEntity
	implements
		IProjectListEntity,
		IListOperations<ProjectListEntity, ProjectItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<IProjectListExtra>
	): ProjectListEntity {
		const inst = new ProjectListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IProjectListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<ProjectItemEntity>
	> {
		return this.availableColumns;
	}
	public setElements(elems: Map<string, ProjectItemEntity>): ProjectListEntity {
		return produce(this, (draft: ProjectListEntity) => {
			draft.elements = elems;
		});
	}
}
